const initialState = {
    responseServicesList: {},
    responseServices: {}
};

const reducer = (state = initialState, action) => {
    const newState = { ...state };
    switch (action.type) {
        case "SERVICES_LIST_RESPONSE":
            newState.responseServicesList = action.value
            break;
        case "SERVICES_RESPONSE":
            newState.responseServices = action.value
            break;
        case "UPLOAD_IMAGE_BACKOFFICE_RESPONSE":
            newState.responseUploadImage = action.value
            break;
        default:
            return newState;
    }

    return newState;
};

export default reducer;